import { render, staticRenderFns } from "./settings_sidebar.vue?vue&type=template&id=4b8c2ee2&scoped=true&"
import script from "./settings_sidebar.vue?vue&type=script&lang=js&"
export * from "./settings_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./settings_sidebar.vue?vue&type=style&index=0&id=4b8c2ee2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c2ee2",
  null
  
)

export default component.exports